import * as React from "react";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
const MobilePay = () => {
  return /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.mobile_pay.info" });
};
export {
  MobilePay
};
//# sourceMappingURL=MobilePay.js.map
